<template>
	<div class="dropdown-label-box d-inline-block">
		<span class="label text-muted" v-if="label && !useLabelInline">{{label}}</span>
		<b-dropdown class="dropdown"
		            :text="selectedItemText"
		            :size="size"
		            :right="right"
		            ref="dropdown">
		    <div v-for="(item, index) in items"
			     :key="item.text"
			     @contextmenu="handleClick($event, index, true)">
				<b-dropdown-item
				                 :active="selectedCurrentItemIndex === index"
				                 @click="handleClick($event, index, false)">
					{{item.text}}
				</b-dropdown-item>
			</div>
		</b-dropdown>
	</div>
</template>
<script>
export default {
	name: 'ErcoDropdownMolecule',
	data() {
		return {
			internalCurrentItemIndex: null,
		};
	},
	mounted() {
		const dropdownComponentElem = this.$refs.dropdown.$el.querySelector('.dropdown-toggle');

		Object.keys(this.styleInfo || {}).forEach((key) => {
			dropdownComponentElem.style[key] = this.styleInfo[key];
		});
	},
	props: {
		label: {
			type: String,
			required: false,
			default: '',
		},
		currentItemIndex: {
			type: Number,
			default: 0,
		},
		items: {
			type: Array,
			required: true,
			default: [],
		},
		right: {
			type: Boolean,
			required: false,
			default: false,
		},
		size: {
			type: String,
			required: false,
			default: '',
		},
		styleInfo: {
			type: Object,
			default: null,
		},
		useLabelInline: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		selectedItemText() {
			if (this.useLabelInline) {
				return this.label;
			}

			return this.items[this.selectedCurrentItemIndex] ?
						this.items[this.selectedCurrentItemIndex].text :
						'';
		},
		selectedCurrentItemIndex() {
			let currentItemIndex =
				(typeof this.internalCurrentItemIndex === 'number') ?
					this.internalCurrentItemIndex :
					this.currentItemIndex;

			currentItemIndex = Math.max(Math.min(currentItemIndex, this.items.length - 1), 0);

			return currentItemIndex;
		},
	},
	methods: {
		handleClick(event, index, rightclick) {
			if (rightclick) {
				event.preventDefault();
			}

			this.internalCurrentItemIndex = index;
			this.$emit('change', {
				currentIndex: this.internalCurrentItemIndex,
				currentText: this.items[this.internalCurrentItemIndex].text,
				currentValue: this.items[this.internalCurrentItemIndex].value,
				rightclick,
			});
		},
		resetSelection() {
			this.internalCurrentItemIndex = null;
		},
	},
};
</script>

<style lang="scss">

	.dropdown-label-box {
		> .dropdown {
			display: block;
		}
	}

</style>



// WEBPACK FOOTER //
// ErcoDropdown.vue?0647eed0